import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { DictionaryDataItem } from '../../model/DictionaryDataItem';
import { CarDictionaryService } from '../../services/car-dictionary.service';
import { FormUtilsService } from '../../services/form-utils.service';

@Component({
  selector: 'app-add-car-model-dictionary-item',
  templateUrl: './add-car-model-dictionary-item.component.html',
  styleUrls: ['./add-car-model-dictionary-item.component.scss']
})
export class AddCarModelDictionaryItemComponent extends DialogContentBase implements OnInit {

  constructor(
    private carDictionaryService: CarDictionaryService,
    private fb:UntypedFormBuilder,
    public dialog: DialogRef,
    private formUtilsService: FormUtilsService,
    private uiNotification: UiNotificationService) { 
      super(dialog); }

  @Input() selectedBrand:string;
  dataForm : UntypedFormGroup;
  data:DictionaryDataItem = {value:''};

  ngOnInit(): void {

    this.dataForm =  this.fb.group({
          value: [this.data.value, [Validators.required, Validators.minLength(1)]]
      });
          
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  confirm() {
   
    if(!this.formUtilsService.markFormGroupTouched(this.dataForm)){
      this.uiNotification.showValidationError();
      return;
    }

    Object.assign(this.data, this.dataForm.value);

      this.carDictionaryService.addCarModel(this.selectedBrand, this.data).subscribe(
        r => { 
          this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
          this.dialog.close({ text: 'OK', newModel: this.data.value });
         });
   }
  
}
